import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerService } from '@data-access/services/customer.service';
import { AppRole } from '@core/models/permission.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  constructor(private customerService: CustomerService) {}

  hasRole(requiredRoles: AppRole[]): Observable<boolean> {
    return this.customerService.getActualRole().pipe(
      map(role => {
        if (!role || !role.label) {
          return false;
        }
        return requiredRoles.some(r => role.label.includes(r));
      })
    );
  }

  hasRoleSync(roleLabel: string | undefined, requiredRoles: AppRole[]): boolean {
    if (!roleLabel) {
      return false;
    }
    return requiredRoles.some(r => roleLabel.includes(r));
  }

  getCurrentRole(): Observable<AppRole | null> {
    return this.customerService.getActualRole().pipe(
      map(role => {
        if (!role || !role.label) {
          return null;
        }
        const found = Object.values(AppRole).find(r => role.label.includes(r));
        return found ?? null;
      })
    );
  }
}
